import React, { useEffect, useState } from "react";
import {Button, FormGroup, FormControl, Container} from "react-bootstrap";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard";
import { isElectron } from "react-device-detect";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "../../blocks/Loader";
import ScrollBlock from "../../blocks/ScrollBlock";
import configApp from "../../../config/config";
import {isTrueProp, focusInput} from "../../../helpers/functions";
import {Animated} from "react-animated-css";

export default function SearchEmp(props) {
    document.title = props.t('Search by name');
    let nodeEmployees = null;
    const [showKeyboard, setShowKeyboard] = useState(true);
    if (props.data instanceof Array && props.data.length > 0) {
        nodeEmployees = props.data.map((employee, index) =>
            <Animated
                key={index}
                animationIn="fadeInDown"
                animationOut="fadeOut"
                animationInDuration={1500}
                animationOutDuration={500}
                isVisible={true}
            >
            <Button key={index} className={"search-emp__emp"} variant="link" onClick={() => props.handleSelectEmployee(employee.uuid)}>
                <div className={"search-emp__emp-name"}>
                    {employee.title}
                </div>
                {employee.position?.length > 0 &&
                    <div className={"search-emp__emp-division"}>
                        {employee.position[0].title}
                    </div>}
            </Button>    </Animated>)
    } else if (props.formErrors?.hasOwnProperty('detail')) {
        nodeEmployees =
            <Animated
                animationIn="shake"
                animationOut="fadeOut"
                animationInDuration={1000}
                animationOutDuration={500}
                isVisible={true}
            >
            <h4 className={`search-emp__notice text-cot-green text-center ${props.formErrors.detail ? "Text_success" : "Text_danger"}`}>
                {props.formErrors.detail ? props.formErrors.detail[0] : props.t("Network Error")}
            </h4> </Animated>
    };

    useEffect(() => {
        focusInput("controlName");
    }, []);

    return <div className="Screen">
            <Container className="p-0 h-100 search-emp-container">
                <h3 className="search-emp-container-title Text_success text-center">{props.t("Search for an employee to undergo pre-shift testing")}</h3>
                <Loader isLoading={props.load.isLoading} loadId={"screen"} className="h-100" justifyContent="center">
                    <div className="search-emp">
                        <FormGroup className="search-emp__name-container text-center ml-4 mr-4 mt-2 d-flex">
                            <FormControl
                                type="text"
                                required
                                onChange={props.onInputName}
                                id="controlName"
                                name="name"
                                className={`search-emp__name-field mx-auto border-secondary form-control`}
                                placeholder={props.t('Enter name')}
                                value={props.formValues.name ? props.formValues.name : ''} />
                            {props.formValues.name &&
                                <Button onClick={props.onClearName} className="search-emp__name-searchButton Btn Btn_happy m-2 display-5">
                                    {props.t('Reset')}
                                </Button>}
                            <Button onClick={props.onSubmit} disabled={(!props.formValid || props.load.isLoading && props.load.idsLoad.includes('listEmployee'))}
                                    className="search-emp__name-searchButton Btn Btn_success m-2 display-5">
                                {props.t('Find')}
                            </Button>
                        </FormGroup>
                        <Loader isLoading={props.load.isLoading} loadId={"listEmployee"} justifyContent="center" style={{height: '100%'}}>
                            <ScrollBlock style={{
                                overflowY: 'auto',
                                display: 'flex',
                                height: '90%',
                                justifyContent: 'flex-start',
                                alignContent: 'center',
                                alignItems: 'stretch',
                                flexDirection: 'column',
                                flexWrap: 'nowrap',
                            }} className="mx-4">
                                {nodeEmployees}
                            </ScrollBlock>
                        </Loader>
                        {(isTrueProp(configApp.device_settings, 'keyboard') || isElectron) &&
                            <div className="keyBoardContainer">
                                <div className="keyboardShowBtn">
                                    <button type="button" className="keyboardShowButtton"
                                            onClick={() => setShowKeyboard(!showKeyboard)}>
                                        <FontAwesomeIcon icon={showKeyboard ? faChevronDown : faChevronUp}/>
                                    </button>
                                </div>
                                <div
                                    className={`mx-4 keywoard-container search-emp_keywoard-container ${showKeyboard ? null : "unShowKeyboardClass"}`}>
                                    <Keyboard className="px-4" {...props.keyboardConfig} />
                                </div>
                            </div>
                            }
                    </div>
                </Loader>
            </Container>
           </div>
};